/**
 * WP Staging basic jQuery replacement
 */

/**
 * Shortcut for document.querySelector() or jQuery's $()
 * Return single element only
 */
export function qs(selector) {
  return document.querySelector(selector);
}

/**
 * Shortcut for document.querySelector() or jQuery's $()
 * Return collection of elements
 */
export function all(selector) {
  return document.querySelectorAll(selector);
}

/**
 * alternative of jQuery - $(parent).on(event, selector, handler)
 */
export function addEvent(parent, evt, selector, handler) {
  parent.addEventListener(evt, function(event) {
    if (event.target.matches(selector + ', ' + selector + ' *')) {
      handler(event.target.closest(selector), event);
    }
  }, false);
}

export function slideDown(element, duration = 400) {
  element.style.display = 'block';
  element.style.overflow = 'hidden';
  const height = element.offsetHeight;
  element.style.height = '0px';
  element.style.transitionProperty = 'height';
  element.style.transitionDuration = duration + 'ms';
  setTimeout(() => {
    element.style.height = height + 'px';
    window.setTimeout(() => {
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, duration);
  }, 0);
}

export function slideUp(element, duration = 400) {
  element.style.display = 'block';
  element.style.overflow = 'hidden';
  const height = element.offsetHeight;
  element.style.height = height + 'px';
  element.style.transitionProperty = 'height';
  element.style.transitionDuration = duration + 'ms';
  setTimeout(() => {
    element.style.height = '0px';
    window.setTimeout(() => {
      element.style.display = 'none';
      element.style.removeProperty('height');
      element.style.removeProperty('overflow');
      element.style.removeProperty('transition-duration');
      element.style.removeProperty('transition-property');
    }, duration);
  }, 0);
}

export function getNextSibling(element, selector) {
  let sibling = element.nextElementSibling;

  while (sibling) {
    if (sibling.matches(selector)) {
      return sibling;
    }

    sibling = sibling.nextElementSibling;
  }
};

export function getParents(element, selector) {
  const result = [];
  for (let parent = element && element.parentElement; parent; parent = parent.parentElement) {
    if (parent.matches(selector)) {
      result.push(parent);
    }
  }

  return result;
}
